/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Masks_DescInputs */

const en_landing_why_masks_desc = /** @type {(inputs: Landing_Why_Masks_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mask marks exactly where an edit may go; everything else must stay.`)
};

const zh_landing_why_masks_desc = /** @type {(inputs: Landing_Why_Masks_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遮罩精确标出可修改区域，其余部分必须保持不变。`)
};

/**
* | output |
* | --- |
* | "A mask marks exactly where an edit may go; everything else must stay." |
*
* @param {Landing_Why_Masks_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_masks_desc = /** @type {((inputs?: Landing_Why_Masks_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Masks_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_masks_desc(inputs)
	return zh_landing_why_masks_desc(inputs)
});
export { landing_why_masks_desc as "landing.why.masks_desc" }